import { render } from "./TestimonialsPage.vue?vue&type=template&id=98022010"
import script from "./TestimonialsPage.vue?vue&type=script&lang=js"
export * from "./TestimonialsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__